module.exports = __webpack_public_path__ + "static/media/chat.22cee3a3.png";